export default {
  CLUB: 'CLUB',
  LOUNGE: 'LOUNGE',
  EVENT_SPACE: 'EVENT_SPACE',
  BAR: 'BAR',
  FESTIVAL: 'FESTIVAL',
  DISPENSARY: 'DISPENSARY',
}



// WEBPACK FOOTER //
// ./src/constants/venueTypes.js